import {useAuth} from "base/auth";
import {AppMenu} from "base/layout";
import {AccountMenu} from "user/component/presentational";
import {SisbagalHelp, SisbagalMenuSearch} from ".";

const SisbagalMenu = () => {
    const {ROLES, hasRole} = useAuth();

    let menuItems = [
        {
            name: "Concellos",
            to: "concellos",
            pathname: "concellos",
        },
        {
            name: "Aglomeracións",
            to: "aglomeracions",
            pathname: "aglomeracions",
        },
    ];
    if (!hasRole(ROLES.CONCELLO)) {
        menuItems = [
            ...menuItems,
            {
                name: "Medio",
                to: "medioreceptor",
                pathname: "medioreceptor",
            },
            {
                name: "Estatísticas",
                to: "stats",
                pathname: "stats",
            },
        ];
    }
    if (
        hasRole(ROLES.ADMINISTRADOR) ||
        hasRole(ROLES.XESTOR) ||
        hasRole(ROLES.EDITOR)
    ) {
        menuItems = [
            ...menuItems,
            {
                name: "Xestión de Cambios",
                to: "changes/approval",
                pathname: "changes/approval",
            },
            {
                name: "Visualización de Datos",
                to: "visualization/data",
                pathname: "visualization/data",
            },
        ];
    }

    return (
        <AppMenu menuItems={menuItems}>
            <SisbagalMenuSearch />
            <AccountMenu />
            <SisbagalHelp />
        </AppMenu>
    );
};

export default SisbagalMenu;
